import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Box } from "@material-ui/core";

interface CardLoadingProps {
  /** Main job-list card. Other screens keep the original skeleton. */
  variant?: "item" | "card";
}

const pill = { borderRadius: 20 };

const CardLoading = ({ variant = "item" }: CardLoadingProps) => {
  if (variant === "card") {
    return (
      <Box className="job-card-wrapper">
        <Box className="card-upper">
          <Box className="job-image">
            <Skeleton className="MuiAvatar-root" variant="circle" />
          </Box>
          <Box className="job-info w-100">
            <Skeleton variant="text" width="55%" height={28} />
            <Box className="job-description">
              <Skeleton variant="text" width="42%" height={20} />
              <Skeleton variant="text" width="64%" height={20} />
            </Box>
          </Box>
        </Box>
        <Box className="card-botttom">
          <Box className="job-tags">
            <Skeleton variant="rect" width={92} height={34} style={pill} />
            <Skeleton variant="rect" width={84} height={34} style={pill} />
            <Skeleton variant="rect" width={168} height={34} style={pill} />
          </Box>
          <Box className="job-footer">
            <Skeleton variant="text" width={160} height={20} />
            <Skeleton variant="rect" width={118} height={40} style={pill} />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <div className="job-item">
      <div className="job-item-header">
        <div className="avatar">
          <Skeleton variant="circle" width={50} height={50} />
        </div>
        <div className="meta">
          <Skeleton />
          <div>
            <Skeleton width={51} />
            <Skeleton width={95} />
          </div>
        </div>
      </div>
      <div className="job-item-content">
        <Skeleton width={314} />
        <Skeleton width={314} />
        <Skeleton width={114} />
      </div>
      <div className="job-item-footer">
        <Skeleton width={127} />
      </div>
    </div>
  );
};

export default CardLoading;
